import { USER_LANGUAGE_CODES } from "./i18n-constants";

const supportedLocales = Object.values(USER_LANGUAGE_CODES);

/**
 * @param {string} locale <language> or <language>-<region> (e.g. en or en-GB)
 * @param {string[]} supportedLocalesList
 */
export function findCloseSupportedLanguage(
  locale,
  supportedLocalesList = supportedLocales,
) {
  if (!locale) {
    return null;
  }

  const lowerCaseLocale = locale?.toLocaleLowerCase();
  const lowerCaseSupportedLocales = supportedLocalesList.map((l) =>
    l?.toLocaleLowerCase(),
  );

  // Return the string with capitalisation from the supportedLocalesList
  const fullMatchIndex = lowerCaseSupportedLocales.findIndex(
    (l) => l === lowerCaseLocale,
  );
  if (fullMatchIndex >= 0) {
    return supportedLocalesList[fullMatchIndex];
  }

  const [language] = lowerCaseLocale.split("-");
  const languageMatchIndex = lowerCaseSupportedLocales.findIndex(
    (l) => l === language,
  );
  if (languageMatchIndex >= 0) {
    return supportedLocalesList[languageMatchIndex];
  }

  return null;
}

/**
 * @param {string | string[]} localeOrLocalesToCheck - could be the output of window.navigator.language or window.navigator.languages (or locales from anywhere else)
 * @param {string} defaultLocaleToReturn - the default locale to return if we can't find anything
 * @param {*} supportedLocalesList
 */
export default function getSupportedLanguage(
  localeOrLocalesToCheck,
  supportedLocalesList = supportedLocales,
) {
  // Test locale used to inject dummy translations to make testing the UI easier
  if (localeOrLocalesToCheck === "te-st") {
    return "te-st";
  }

  let locales = Array.isArray(localeOrLocalesToCheck)
    ? localeOrLocalesToCheck
    : [localeOrLocalesToCheck];

  // TODO: remove this when we migrate en users to en-gb
  locales = locales.map((locale) => {
    if (locale === "en" || locale?.startsWith("en-")) {
      return "en-gb";
    }
    return locale;
  });

  // Make sure we return the capitalisation from the supported list
  const localesWeSupport = locales
    .map((l) => findCloseSupportedLanguage(l, supportedLocalesList))
    .filter(Boolean);

  if (localesWeSupport.length) {
    return localesWeSupport[0];
  }

  return null;
}
